import { POSAnimatedImage } from '@publicisgroupe/p-os-components';
import { Dimmer, Segment } from 'semantic-ui-react';
import { t } from '../../utils/resources';
import './POSLoader.less';

export type POSLoaderProps = {
  showLoadingText: boolean;
  loadingText?: string;
};

export const POSLoader = (props: POSLoaderProps) => {
  return (
    <>
      <div className="anim-loader">
        <Segment>
          <Dimmer active>
            <POSAnimatedImage image="LoadingWhiteDelay" size="small" />
            {props.showLoadingText && <p>{t('Loader.Text')}</p>}
            {!props.showLoadingText && props.loadingText && <p>{props.loadingText}</p>}
          </Dimmer>
        </Segment>
      </div>
    </>
  );
};
